import React from 'react';
import styles from './index.module.scss';
import { Button } from '@mui/material';
import classNames from 'classnames';
import { ReactComponent as HomeImage } from '../../../../assets/images/Login/homeImg.svg';

export const DownloadAppContent = ({ url }: { url?: string }) => (
  <div
    className={classNames(
      styles.contentDataContainer,
      'flex  flex-col text-base font-normal text-neutrals-n-400 w-full items-start text-left gap-4',
    )}
  >
    <div className="flex gap-4">
      <div className="w-1/2 flex justify-center">
        <HomeImage className={styles.homeImg} />
      </div>
      <div className="w-1/2">
        To measure your patients and manage your virtual clinic on your mobile device{' '}
        <span className="font-bold">download the OneStep mobile app.</span>
      </div>
    </div>
    <Button
      className={styles.downloadBtn}
      variant="contained"
      color="primary"
      disabled={!url}
      onClick={() => window.location.replace(url!)}
      role="link"
    >
      Download app
    </Button>{' '}
  </div>
);
